import type { SharedProfileData } from '../types/shared-profile';

export function getSharedProfileDisplayName(
  profile: SharedProfileData | null | undefined,
  email?: string | null,
): string {
  return (
    profile?.opp_username ||
    profile?.display_name ||
    profile?.username ||
    email?.split('@')[0] ||
    '用户'
  );
}

export function getSharedProfileAvatar(
  profile: SharedProfileData | null | undefined,
): string | null {
  return profile?.opp_avatar_url || profile?.avatar_url || null;
}

export function getSharedProfileBio(
  profile: SharedProfileData | null | undefined,
): string | null {
  return profile?.opp_bio || profile?.bio || null;
}
